import { listOrgEnrollments } from "./enrollmentHelpers"
import { toMillis } from "./dateRangeHelpers"

const HOUR_MS = 3600000
const DAY_MS = 86400000

const MONTH_LABELS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

const RANGE_CONFIG = {
  "24h": { unit: "hour", count: 24 },
  "3d": { unit: "day", count: 3 },
  "1w": { unit: "day", count: 7 },
  "1m": { unit: "day", count: 30 },
  "1y": { unit: "month", count: 12 },
}

const buildBucketDefs = (rangeKey) => {
  const config = RANGE_CONFIG[rangeKey] || RANGE_CONFIG["1w"]
  const now = new Date()
  const buckets = []

  if (config.unit === "hour") {
    for (let i = config.count - 1; i >= 0; i--) {
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() - i, 0, 0, 0)
      buckets.push({
        start: start.getTime(),
        end: start.getTime() + HOUR_MS,
        label: start.toLocaleTimeString([], { hour: "numeric" }),
      })
    }
  } else if (config.unit === "day") {
    for (let i = config.count - 1; i >= 0; i--) {
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - i, 0, 0, 0, 0)
      // Weekday names for a 3D/1W window, plain day numbers once it's a 30-day
      // window (12 "Mondays" in a row tells you nothing).
      const label = config.count <= 7 ? start.toLocaleDateString([], { weekday: "short" }) : String(start.getDate())
      buckets.push({ start: start.getTime(), end: start.getTime() + DAY_MS, label })
    }
  } else if (config.unit === "month") {
    for (let i = config.count - 1; i >= 0; i--) {
      const start = new Date(now.getFullYear(), now.getMonth() - i, 1, 0, 0, 0, 0)
      const end = new Date(now.getFullYear(), now.getMonth() - i + 1, 1, 0, 0, 0, 0)
      buckets.push({ start: start.getTime(), end: end.getTime(), label: MONTH_LABELS[start.getMonth()] })
    }
  }

  return buckets
}

// Enrollments and completions per bucket, both computed directly off enrollment
// docs — enrolledAt for the enrollments series, completedAt for completions (see
// the completedAt addition in toggleLessonCompletion, enrollmentHelpers.js).
// No dependency on learningEvents, so this works at any granularity down to the
// hour with a single Firestore query.
export const computeEnrollmentCompletionSeries = async (orgId, rangeKey) => {
  const { enrollments } = await listOrgEnrollments(orgId)
  const buckets = buildBucketDefs(rangeKey)

  return buckets.map((bucket) => {
    const enrollmentCount =
      enrollments?.filter((e) => {
        const ms = toMillis(e?.enrolledAt)
        return ms !== null && ms >= bucket.start && ms < bucket.end
      })?.length || 0

    const completionCount =
      enrollments?.filter((e) => {
        const ms = toMillis(e?.completedAt)
        return ms !== null && ms >= bucket.start && ms < bucket.end
      })?.length || 0

    return { label: bucket.label, enrollments: enrollmentCount, completions: completionCount }
  })
}